import React from 'react'
import { Thing, WithContext } from 'schema-dts'

interface Props {
  schemas: Array<WithContext<Thing>> // JSON 스키마 객체들
}

/**
 * Structured Data 컴포넌트
 * JSON-LD 형식의 구조화된 데이터를 렌더링
 * undefined 값들을 자동으로 제거하고 깔끔하게 출력
 */
const StructuredData: React.FC<Props> = ({ schemas }) => {
  // null, undefined 제거 및 빈 객체 필터링
  const validSchemas = schemas
    .filter((schema) => schema != null)
    .map(cleanSchema)
    .filter((schema) => schema != null && Object.keys(schema).length > 0)

  if (validSchemas.length === 0) {
    return null
  }

  // 각 스키마를 개별 script 태그로 렌더링 (Google 권장사항)
  return (
    <>
      {validSchemas.map((schema, index) => (
        <script
          key={`schema-${index}-${schema['@type'] || 'unknown'}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema, null, 0), // 압축된 형태로 출력
          }}
        />
      ))}
    </>
  )
}

/**
 * 스키마 객체에서 undefined 값들을 재귀적으로 제거
 */
function cleanSchema(obj: any): any {
  if (obj === null || obj === undefined) {
    return null
  }

  if (Array.isArray(obj)) {
    const cleaned = obj.map((item) => cleanSchema(item)).filter((item) => item !== null && item !== undefined)
    return cleaned.length > 0 ? cleaned : null
  }

  if (typeof obj === 'object') {
    const cleaned: any = {}

    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = cleanSchema(value)
      if (cleanedValue !== null && cleanedValue !== undefined) {
        cleaned[key] = cleanedValue
      }
    }

    return Object.keys(cleaned).length > 0 ? cleaned : null
  }

  return obj
}

export default StructuredData
